<template>
    <div class="privacy">
        {{this.privacy}}
    </div>
</template>

<script>
export default {
    name:'privacy',
    data() {
        return {
           privacy:'嗨'
        }
    },
}
</script>

<style lang="less" scoped>
   .privacy{
       width: 100%;
       height: 500px;
       background-color: rgb(224, 36, 124);
   }
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/privacy.vue